<template>
  <z-button
    v-tooltip.bottom="'Ver Actividad'"
    fit="auto"
    variant="secondary"
    class="px-4"
    @click="handleClick"
  >
    <z-icon id="logs" name="Logs" view-box="0 0 17 14" size="18" color="#000" />
  </z-button>
</template>

<script>
import Owner from "@zubut/common/src/constants/logs/owner";

export default {
  name: "ActivityButton",

  props: {
    type: {
      type: String,
      default: "client",
      validator: val =>
        ["client", "driver", "admin", "service"].indexOf(val) > -1
    },

    id: {
      type: String,
      default: ""
    }
  },

  computed: {
    makeQuery() {
      switch (this.type) {
        case "driver":
          return { driver: this.id, rol: Owner.NUM_DRIVER };
        case "client":
          return { client: this.id, rol: Owner.NUM_CLIENT };
        case "admin":
          return { admin: this.id, rol: Owner.NUM_ADMIN };
        case "service":
          return { service: this.id };
        default:
          return { client: this.id, rol: Owner.NUM_CLIENT };
      }
    }
  },
  methods: {
    handleClick() {
      this.$router.push({ name: "logs", query: this.makeQuery });
    }
  }
};
</script>
